import { apiFactory } from "../api_factory";

export const eventsApi = apiFactory({
  path: "/api/v4/events"
});
